import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Authenticated } from "./Authenticated";
import UserContext from "./UserContext";
import { Form, FormControl, Button } from "react-bootstrap"
import { ApiHelper, LoginRequestInterface, LoginResponseInterface, UserHelper } from "./helpers";
import { ErrorMessages } from "./components";

export const Login: React.FC = (props: any) => {
  //const [errors, setErrors] = React.useState<string[]>([])
  const [cookies, setCookie] = useCookies();
  let { from } = (useLocation().state as any) || { from: { pathname: "/" } };
  const context = React.useContext(UserContext);

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [errors, setErrors] = React.useState<string[]>([]);

  let search = new URLSearchParams(props.location.search);
  let jwt = search.get("jwt") || cookies.jwt;
  let guid = search.get("guid");
  if (!jwt) jwt = "";
  if (!guid) guid = "";

  const init = () => {
    if (guid) login({ resetGuid: guid });
    else if (jwt) { login({ jwt: jwt }); }
  };


  React.useEffect(init, []); //eslint-disable-line

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.currentTarget.id) {
      case "email": setEmail(e.currentTarget.value); break;
      case "password": setPassword(e.currentTarget.value); break;
    }
  }

  const login = async (req: LoginRequestInterface) => {
    let errors:string[] = [];
    setIsSubmitting(true);
    const resp: LoginResponseInterface = await ApiHelper.postAnonymous("/users/login", req);
    if (!resp.user) {
      if (req.email) {
        if (resp.errors?.length>0) errors = resp.errors;
        else errors = ["Sorry, the admin is currently down for maintenance.  Please check back in 30 minutes."];
      }
      else window.location.href = "/logout";
    }
    else if (resp.departments.length === 0) errors.push("User does not have access to any accounts.");
    else {
      UserHelper.user = resp.user;
      UserHelper.departments = resp.departments;
      UserHelper.currentDepartment = resp.departments[0];
      //UserHelper.departmentChanged = true;
      ApiHelper.setDefaultPermissions(UserHelper.currentDepartment.jwt);
      ApiHelper.isAuthenticated = true;
      context.setUserName(UserHelper.currentDepartment.id.toString());
      setCookie("jwt", UserHelper.currentDepartment.jwt, { path: "/" });
    }
    setIsSubmitting(false);
    setErrors(errors);
  }

  const handleSubmit = (e: React.MouseEvent) => {
    let errors: string[] = [];
    if (email.length === 0) errors.push("Please enter an email address.");
    if (password.length === 0) errors.push("Please enter a password.");
    if (errors.length === 0) login({ email: email, password: password });
    setErrors(errors);
  }

  const getLoginBox = () => {
    return (
      <div id="loginBox" >
        <h2>Please sign in</h2>
        <ErrorMessages errors={errors} />


        <Form.Group>
          <FormControl type="text" aria-label="email" id="email" value={email} onChange={handleChange} placeholder="Email address" />
        </Form.Group>
        <Form.Group>
          <FormControl type="password" aria-label="email" id="password" value={password} onChange={handleChange} placeholder="Password" />
        </Form.Group>
        <Button type="submit" id="signInButton" size="lg" variant="primary" block disabled={isSubmitting} style={{ width: "100%" }} onClick={handleSubmit}>
          {(isSubmitting) ? "Please wait..." : "Sign in"}
        </Button>


        <br />
        <div className="text-right">
          <a href="https://signpresenter.com/#signUp">Register</a> | <Link to="/forgot">Forgot Password</Link>
        </div>
      </div>
    );
  }




  if (context.userName === "" || !ApiHelper.isAuthenticated) {
    return (<div className="smallCenterBlock">{getLoginBox()}</div>);
  } else {
    let path = from.pathname;
    let search = new URLSearchParams(props.location.search);
    const returnUrl = search.get("returnUrl");
    if (returnUrl) path = returnUrl;

    return <Authenticated location={path}></Authenticated>;
  }
};